import styled from 'styled-components';

export const Container = styled.div`
  iframe {
    display: block;
    border: none;
    width: 100%;

    max-width: 900px;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    margin-top: 20rem;
  }
`;

export const CategoryID = styled.div`
  font-family: Montserrat;
  position: relative;
  max-width: 1300px;
  margin: 0 auto;

  .list-container_idtwo {
    position: absolute;
    right: -0.1rem;
    top: 0.2rem;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-container_id {
    position: fixed;
    right: 13%;
    top: 130px;
    z-index: 10;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-items_id {
    padding: 1.3rem;
    display: flex;
    flex-direction: column;

    .newsletter_id {
      width: 100%;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1rem;
      text-transform: capitalize;
      font-weight: bold;
      color: #2253f5;
      background: #fcff7c;
      border-radius: 100px;
    }

    p {
      margin-top: 0.7rem;
      margin-bottom: -0.8rem;
      font-weight: 300;
      font-size: 16px;
      color: #2253f5;
    }

    a {
      text-decoration: none;
      font-size: 0.875rem;
      color: #333333;
      text-transform: uppercase;
      margin-top: 1.5625rem;

      line-height: 140.62%;
      transition: all 0.2s ease-in-out;
    }

    a:hover {
      color: #2253f5;
      font-weight: bold;
      transform: scale(1.05);
    }
  }
  @media (max-width: 768px) {
    display: none;
  }

  @media (max-width: 1440px) {
    .list-container_id {
      right: 2rem;
    }
  }

  @media screen and (min-width: 2560px) {
    .list-container_id {
      right: 37rem;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
